import type {z} from "zod";

import {EditMaterialDescriptionBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {materialDescriptionFieldLabelIds} from "../../../../../messages/material-description.messages";

const fields = EditMaterialDescriptionBody.shape;
export const editMaterialDescriptionFormSchema = zod.object({
  text: requiredStringSchema(fields.text, materialDescriptionFieldLabelIds.text),
});
export type EditMaterialDescriptionFormPayload = z.output<typeof editMaterialDescriptionFormSchema>;

export const draftEditMaterialDescriptionFormSchema = editMaterialDescriptionFormSchema.partial();
export type DraftEditMaterialDescriptionFormPayload = z.output<
  typeof draftEditMaterialDescriptionFormSchema
>;
